<template>
  <div id="about">
    <!--HEADER-->
    <header class="header--small"  id="isi-quality-labels-intro"></header>
    <!--/.HEADER-->
    <!-- SECTION 1 NEU-->
   <!--  <section class="section mt-5">
      <mdb-container>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <h2 class="section__heading">isi Test Studio Finder</h2>
          </mdb-col>
          <div class="w-100"></div>
        </mdb-row>
        <mdb-row class="justify-content-center">
          <mdb-col lg="8">
            <ul class="section__feature-list pl-0 mt-4">
              <li class="section__feature-list-item">
                <span class="section__feature-list-item-heading"
                  >Fast and convenient</span
                >
                <p class="section__feature-list-item-content">
                  Your one-stop gateway – isi is your direct contact and your
                  only contract partner for booking
                  <span class="d-xl-block"></span>
                  the test studios: 1 request, 1 supplier in your system, 1
                  contract, 1 invoice.
                </p>
              </li>
              <li class="section__feature-list-item mt-4">
                <span class="section__feature-list-item-heading"
                  >Quality assurance</span
                >
                <p class="section__feature-list-item-content">
                  Handpicked partners, certified with our isi QualityLabels. We
                  find the ‘local jewels’ and make
                  <span class="d-xl-block"></span>them available for your
                  project.
                </p>
              </li>
              <li class="section__feature-list-item mt-4">
                <span class="section__feature-list-item-heading"
                  >Transparent</span
                >
                <p class="section__feature-list-item-content">
                  Check floor plans and photos. Download detailed studio
                  information. <span class="d-xl-block"></span> Experience
                  virtual tours.
                </p>
              </li>
              <li class="section__feature-list-item mt-4">
                <span class="section__feature-list-item-heading">Flexible</span>
                <p class="section__feature-list-item-content">
                  Book what you need – from field-only studies over additional
                  field support to full-service project.
                </p>
              </li>
            </ul>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section> -->
    <!-- ./SECTION 1 NEU-->
 <!--    <hr /> -->
    <!-- SECTION 2 NEU-->
    <section class="section my-5">
      <mdb-container>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <h2 class="section__heading">The isi QualityLabels</h2>
          </mdb-col>
          <div class="w-100"></div>
          <mdb-col class="d-flex justify-content-center">
            <h3 class="section__sub-heading section__quote text-center">
              "We certify our partners according to the high isi standards."
            </h3>
          </mdb-col>
        </mdb-row>

        <mdb-row class="justify-content-center mt-5">
          <mdb-col lg="8">
            <mdb-row>
              <mdb-col>
                <img
                  class="section__feature-gallery-item"
                  src="../assets/images/logos/isi-certified-1-400-compressed.png"
                />
              </mdb-col>
              <mdb-col>
                <img
                  class="section__feature-gallery-item"
                  src="../assets/images/logos/isi-certified-2-400-compressed.png"
                />
              </mdb-col>
              <mdb-col>
                <img
                  class="section__feature-gallery-item"
                  src="../assets/images/logos/isi-certified-3-400-compressed.png"
                />
              </mdb-col>
              <mdb-col>
                <img
                  class="section__feature-gallery-item"
                  src="../assets/images/logos/isi-certified-4-400-compressed.png"
                />
              </mdb-col>
            </mdb-row>
          </mdb-col>
        </mdb-row>
        <mdb-row class="justify-content-center mt-5">
          <mdb-col lg="8">
            <p class="section__content">
              The isi QualityLabels are exclusively awarded to selected isi
              fieldwork partner facilities, after the verification of required
              quality control measures. At a glance, you see which test studios
              are <span class="d-xl-block"></span>optimal for your project.
            </p>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <a
              class="section__learn-more-link btn btn-lg btn-light-green mt-3"
              href="#isi-quality-labels"
              v-mdb-smooth
              >Learn more</a
            >
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>
    <!-- ./SECTION 2 NEU-->

    <hr />
    <!-- SECTION 3 NEU-->
    <section class="section my-5">
      <mdb-container>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <h2 class="section__heading">Certification Process</h2>
          </mdb-col>
          <div class="w-100"></div>
          <mdb-col class="d-flex justify-content-center">
            <h3 class="section__sub-heading text-center">
              The path to reaching the isi quality standards
            </h3>
          </mdb-col>
        </mdb-row>

        <mdb-row class="justify-content-center mt-5">
          <mdb-col lg="8">
            <p class="section__content">
              Based on audits and re-visits we assist our fieldwork partners to
              develop and continiously improve
              <span class="d-xl-block"></span> all the required standards and
              ensure compliance. Each facility is inspected before they can
              become part of our network. The isi standards refer to the
              professionalism of staff, processes and infrastructure.
            </p>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>
    <!-- ./SECTION 3 NEU-->

    <!-- SECTION 4 NEU-->
    <section class="section my-5" >
      <mdb-container fluid>
        <mdb-row>
          <mdb-col class="px-0">
            <picture>
              <source
                srcset="
                  ~@/assets/images/about-section-certification-process-551-compressed.jpg
                "
                media="(max-width: 37.5em)"
                width="100%"
              />
              <img
                srcset="
                  ~@/assets/images/about-section-certification-process-1280-compressed.png
                "
                alt="isi-certification-processs"
                width="100%"
              />
            </picture>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>
    <!-- SECTION 5 NEU-->
    <section class="section my-5">
      <a id="isi-quality-labels">anchor</a>
      <mdb-container>
        <mdb-row>
          <mdb-col class="d-flex justify-content-center">
            <h2 class="section__heading text-center">
              What do the isi QualityLabels stand for?
            </h2>
          </mdb-col>
          <div class="w-100"></div>
          <mdb-col class="d-flex justify-content-center">
            <h3 class="section__sub-heading">Quick orientation</h3>
          </mdb-col>
        </mdb-row>

        <mdb-row class="justify-content-center mt-5">
          <mdb-col lg="10">
            <mdb-row>
              <mdb-col
                md="3"
                class="
                  d-flex
                  justify-content-center justify-content-md-start
                  align-items-center
                "
              >
                <img
                  class="section__feature-gallery-item"
                  src="../assets/images/logos/isi-certified-1-400-compressed.png"
                />
              </mdb-col>
              <mdb-col
                class="d-flex align-items-center mt-5 mt-md-0 ml-4 ml-md-0"
              >
                <ul class="section__list isi-list">
                  <li>Fixed test booths</li>
                  <li>
                    Fully controlled test environment including room
                    temperature, light and odor
                  </li>
                  <li>
                    Neutral air-conditioned room with powerful automatic
                    ventilation &#38; exhaustion
                  </li>
                  <li>A close by and separated kitchen or preparation area</li>
                  <li>Storage space and cooling capacity</li>
                </ul>
              </mdb-col>
            </mdb-row>

            <hr class="d-md-none" />

            <mdb-row class="mt-5 mt-md-4">
              <mdb-col
                md="3"
                class="
                  d-flex
                  justify-content-center justify-content-md-start
                  align-items-center
                "
              >
                <img
                  class="section__feature-gallery-item"
                  src="../assets/images/logos/isi-certified-2-400-compressed.png"
                />
              </mdb-col>
              <mdb-col
                class="d-flex align-items-center mt-5 mt-md-0 ml-4 ml-md-0"
              >
                <ul class="section__list isi-list">
                  <li>At least one multipurpose room with ventilation</li>
                  <li>
                    Enough space to set up test booths or test places in a way
                    that product evaluation can be carried out individually
                  </li>
                  <li>Separated kitchen or product preparation area</li>
                  <li>Storage space and cooling capacity</li>
                </ul>
              </mdb-col>
            </mdb-row>
            <hr class="d-md-none" />
            <mdb-row class="mt-5 mt-md-4">
              <mdb-col
                md="3"
                class="
                  d-flex
                  justify-content-center justify-content-md-start
                  align-items-center
                "
              >
                <img
                  class="section__feature-gallery-item"
                  src="../assets/images/logos/isi-certified-3-400-compressed.png"
                />
              </mdb-col>
              <mdb-col
                class="d-flex align-items-center mt-5 mt-md-0 ml-4 ml-md-0"
              >
                <ul class="section__list isi-list">
                  <li>
                    Group discussion room with enough space for tables and seats
                  </li>
                  <li>
                    Observation possibility such as one-way mirror and
                    video-audio observation
                  </li>
                  <li>
                    Availability and access to translators (Local language to
                    English)
                  </li>
                  <li>
                    Availability and access to experienced qualitative
                    researchers and moderators
                  </li>
                </ul>
              </mdb-col>
            </mdb-row>
            <hr class="d-md-none" />
            <mdb-row class="mt-5 mt-md-4">
              <mdb-col
                md="3"
                class="
                  d-flex
                  justify-content-center justify-content-md-start
                  align-items-center
                "
              >
                <img
                  class="section__feature-gallery-item"
                  src="../assets/images/logos/isi-certified-4-400-compressed.png"
                />
              </mdb-col>
              <mdb-col
                class="d-flex align-items-center mt-5 mt-md-0 ml-4 ml-md-0"
              >
                <ul class="section__list isi-list">
                  <li>
                    Product preparation and packing area with storage space and
                    cooling capacity
                  </li>
                  <li>
                    In-time product handling which can include product blinding
                    and parcel packaging
                  </li>
                  <li>
                    Product distribution, which can include shipping and the
                    coordination of parcel pick up
                  </li>
                  <li>Quality control procedures and tracking of fieldwork</li>
                </ul>
              </mdb-col>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>
    <!-- ./SECTION 5 NEU-->

    <app-footer />
  </div>
</template>

<script>
import AppFooter from "../components/Footer.vue";
import { mdbSmooth } from "mdbvue";
export default {
  components: { AppFooter },

  directives: {
    mdbSmooth,
  },
  name: "About",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "About",
    // all titles will be injected into this template
    titleTemplate: "%s | isi Test Studio Finder",
  },
};
</script>

<style scoped lang="scss">
#isi-quality-labels {
  display: block;
  visibility: hidden;
  position: relative;
  top: -80px;
}
@import "~@/styles/parts/_section.scss";
@import "~@/styles/views/_headers.scss";
</style>